import { ReactNode, useState } from "react";
import clsx from "clsx";
import SimpleIconButton from "./SimpleIconButton.tsx";
import { ClickAwayListener, IconButton, Paper } from "@mui/material";

type SimpleDoubleCheckingProps = {
	ariaLabel?: string;
	className?: string;
	color?: string;
	confirmationButtonBackgroundColor?: string;
	confirmationButtonColor?: string;
	confirmationIcon?: ReactNode;
	confirmationSx?: any;
	disabled?: boolean;
	icon: ReactNode;
	iconHover?: ReactNode;
	loading?: boolean;
	loadingIcon?: string;
	mainButtonClasses?: string;
	onDeleteAction?: () => void;
	size?: "small" | "medium" | "large";
	sx?: any;
};
export default function SimpleDoubleChecking(props: Readonly<SimpleDoubleCheckingProps>) {
	const { mainButtonClasses = "" } = props;
	const [showConfirmation, setShowConfirmation] = useState(false);

	const handleClickIn = () => {
		setShowConfirmation(true);
	};

	const handleRemove = () => {
		setShowConfirmation(false);

		if (props.onDeleteAction) {
			props.onDeleteAction();
		}
	};

	const handleClickAway = () => {
		setShowConfirmation(false);
	};

	return (
		<ClickAwayListener onClickAway={handleClickAway}>
			<Paper
				elevation={0}
				sx={props.sx}
				style={{
					backgroundColor: "transparent",
					transition: "all .2s ease-in-out",
					position: "relative",
					display: "content",
					alignItems: "center",
				}}
			>
				<IconButton
					aria-label={props.ariaLabel ?? "Button"}
					size={props.size ?? "medium"}
					className={clsx({
						[mainButtonClasses]: true,
						"simple-icon-button": true,
					})}
					disabled={props.disabled || props.loading || false}
					style={{
						color: props.confirmationButtonColor,
						backgroundColor: props.confirmationButtonBackgroundColor,
						opacity: showConfirmation ? "100%" : "0%",
						position: "absolute",
					}}
					sx={props.confirmationSx || null}
					onClick={handleRemove}
				>
					{props.confirmationIcon}
				</IconButton>

				<SimpleIconButton
					className={props.className}
					color={props.color}
					disabled={props.disabled || props.loading || false}
					icon={props.icon}
					iconHover={props.iconHover}
					loadingIcon={props.loadingIcon}
					loading={props.loading}
					sx={{
						opacity: showConfirmation ? "0%" : "100%",
						visibility: showConfirmation ? "hidden" : "inherit",
					}}
					onClick={handleClickIn}
				/>
			</Paper>
		</ClickAwayListener>
	);
}
